import { gql, useMutation } from '@apollo/client';
import { FlagAssistantResponseInput, Mutation } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

const FLAG_ASSISTANT_RESPONSE = gql`
  mutation flagAssistantResponse(
    $tenantID: ID!
    $userID: ID!
    $responseID: ID!
    $isResponseGood: Boolean!
    $reasons: [String!]
    $comments: String
    $viewToken: ID
    $sessionID: ID
  ) {
    flagAssistantResponse(
      request: {
        tenantID: $tenantID
        userID: $userID
        responseID: $responseID
        isResponseGood: $isResponseGood
        reasons: $reasons
        comments: $comments
        viewToken: $viewToken
        sessionID: $sessionID
      }
    )
  }
`;

export function useFlagAssistantResponse() {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();
  const [flagAssistantResponse, resp] = useMutation<
    Mutation,
    FlagAssistantResponseInput
  >(FLAG_ASSISTANT_RESPONSE, {
    fetchPolicy: 'network-only',
  });

  const flagAssistantResponseCB = useCallback(
    async ({
      comments,
      ...input
    }: Omit<FlagAssistantResponseInput, 'tenantID' | 'userID'>) => {
      return flagAssistantResponse({
        variables: {
          ...input,
          comments: comments?.trim(),
          tenantID,
          userID,
          viewToken: input.viewToken || undefined, // BE expects undefined for empty token, instead of empty string
        },
      });
    },
    [tenantID, userID, flagAssistantResponse],
  );

  return [flagAssistantResponseCB, resp] as const;
}
